export default "__VITE_ASSET__a9aa7c47__"